import { Components, Theme, typographyClasses } from '@mui/material';

export const MuiListSubheader: Components<Theme>['MuiListSubheader'] = {
  variants: [
    {
      // Non-sticky list title with card gutters and a divider underneath. Pairs with the Typography `watchduty-section-header`
      // variant for headers that aren't inside a List.
      props: { variant: 'watchduty-section-header' },
      style: ({ theme }) => ({
        position: 'static',
        color: 'inherit',
        lineHeight: 1,
        padding: theme.spacing(3, 2, 2),
        borderBottom: `1px solid ${theme.vars.palette.divider}`,
        [`& .${typographyClasses.h3}`]: {
          fontWeight: theme.typography.fontWeightBold,
        },
      }),
    },
  ],
};
